// Wrap-up notes seeding (2026-09-15).
//
// Priority for what the wrap-up textarea opens with, highest first:
//   1. what the agent typed live during the call (ContactContext.callNotes)
//   2. the D28 sessionStorage mirror of the same (a reload mid-call / mid-ACW)
//   3. the bot leg's AI summary (contact attribute aiSummary, already
//      display-filtered by lib/summary.js) — ONLY when 1 and 2 are empty
//   4. empty
// An agent's own words are never replaced by AI text. Calls with no aiSummary
// (agent-handled from the start, outbound) fall through to 4 exactly as before;
// nothing here synthesises a summary from the transcript.
export function initialWrapNotes({ liveNotes, storedNotes, aiSummary } = {}) {
  if (liveNotes && String(liveNotes).trim()) return liveNotes;
  if (storedNotes && String(storedNotes).trim()) return storedNotes;
  if (aiSummary && String(aiSummary).trim()) return aiSummary;
  return '';
}

// What the wrap-up opens with AND whether that text came from the AI summary.
// `aiSeeded` is true only when the summary was the source (1 and 2 empty), or
// when the stored mirror is still exactly the summary (a reload mid-ACW after
// seeding, before any edit). It is held in ContactContext for the life of the
// wrap-up so the cue persists until Save (Storm, 2026-09-15): the agent's
// edits do not make the provenance line go away — the notes still began as
// the bot leg's account of the call, and they go on record.
export function wrapNotesSeed({ liveNotes, storedNotes, aiSummary } = {}) {
  const notes = initialWrapNotes({ liveNotes, storedNotes, aiSummary });
  const summary = aiSummary && String(aiSummary).trim() ? aiSummary : '';
  const fromLive = Boolean(liveNotes && String(liveNotes).trim());
  const aiSeeded = Boolean(summary) && (
    (!fromLive && notes === summary)
  );
  return { notes, aiSeeded };
}

// Exact-match check (notes are still verbatim the summary). Kept for tests and
// for any caller that wants the narrower "untouched" question.
export function notesAreAiSeeded(notes, aiSummary) {
  return Boolean(aiSummary) && notes === aiSummary;
}
